import { DropdownItem } from '@ardoq/dropdown-menu';
import {
  ViewIds,
  APIComponentAttributes,
  APIWorkspaceAttributes,
} from '@ardoq/api-types';
import type { SettingsConfig } from '@ardoq/view-settings';
import { RepresentationData } from '@ardoq/data-model';
import type { I18nLocale } from '@ardoq/i18n';

export const VIEW_ID = ViewIds.ROADMAP;

// Generic tree type
export type Tree<T> = {
  data: T;
  children: Tree<T>[];
};

type ComponentEntity = { type: 'component'; data: APIComponentAttributes };
type WorkspaceEntity = { type: 'workspace'; data: APIWorkspaceAttributes };
// Hierarchy entity types
export type HierarchyEntity = WorkspaceEntity | ComponentEntity;

export const isComponentEntity = (
  entity: HierarchyEntity
): entity is ComponentEntity => entity.type === 'component';

export type RoadmapViewSettings = {
  selectedFieldName?: string;
};

export type ComponentData = {
  content: string;
  cssClass: string;
  componentId: string;
  representationData: RepresentationData;
};

export type TableCell = {
  content?: string;
  components?: ComponentData[];
};

export type LegendItem = {
  id: string;
  name: string;
  cssClass: string;
  representationData: {
    isImage: boolean;
    value: string | null;
    icon: any;
  };
};

export type RoadmapViewProps = {
  selectedFieldName?: string;
  selectedFieldLabel?: string;
  selectedFieldValues: string[];
  fieldOptions: DropdownItem[];
  tableRows: TableCell[][];
  legend: LegendItem[];
  rightMenu: SettingsConfig[];
  i18nLocale: I18nLocale;
};
